import React, { useState, useRef, useEffect } from 'react';

// devExtreme
import ScrollView from 'devextreme-react/scroll-view';

interface FuncProps {
  passHeightToChild: true;
  children(scrollViewHeight: number | null): JSX.Element | null;
}

interface RenderJSXProps {
  passHeightToChild?: false;
  children: React.ReactChildren | React.ReactChild | null;
}

type ScrollableProps = { heightAuto?: boolean } & (FuncProps | RenderJSXProps);

const Scrollable = ({
  heightAuto,
  children,
  passHeightToChild = false
}: ScrollableProps): JSX.Element => {
  const scrollableWrapperRef = useRef<HTMLDivElement>(null);

  const [scrollViewHeight, setScrollViewHeight] = useState<number | null>(null);

  useEffect(() => {
    setScrollViewHeight(scrollableWrapperRef.current?.clientHeight || null);
  }, []);

  return (
    <div className="scrollable" ref={scrollableWrapperRef}>
      {(scrollViewHeight || heightAuto) && (
        <ScrollView
          height={heightAuto ? '100%' : scrollViewHeight || undefined}
        >
          {passHeightToChild && typeof children === 'function'
            ? children(scrollViewHeight)
            : children}
        </ScrollView>
      )}
    </div>
  );
};

export default Scrollable;
